import { Type } from 'typebox';
import { DocumentationRating } from '../reference/documentation-rating.js';
import { Event } from './event.js';
export const DocumentationEvent = Type.Evaluate(Type.Intersect([
    Event,
    Type.Object({
        type: Type.Literal('Documentation'),
        observationId: Type.Optional(Type.String({ minLength: 1 })),
        dimensionIds: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        ratings: Type.Optional(Type.Array(DocumentationRating))
    })
]));
